import { MerCalculator, MerTranslations } from "cat-mer-calculator";

declare const translations: [key: string] & MerTranslations


// Calculator library
const calculator: MerCalculator = new MerCalculator();

// Initialization
document.addEventListener("DOMContentLoaded", () => {   
    // Calorie calculator forms
    document.querySelectorAll(".calories_calculator").forEach(mainElement => {
        const out = calculator.createCatEnergyForm(mainElement as HTMLElement, translations, "");
        out.weight.step = "0.1";
        
        // resetting and storing values
        const loadFromStorage = () => {
            const data = window.localStorage.getItem("calories_data_new")
            let stored = {
                weight: "4",
                age: '>12',
                activity: 'active',
                peculiarities: 'none',
                numberKittens: "4",
                calories: ""+Math.round(calculator.calculateEnergyRequirements(4, 13, false, true))
            }
            if(data != null) {
                stored = JSON.parse(data);
            }
            out.weight.value = stored.weight;
            out.age.value = stored.age;
            out.activity.value = stored.activity;
            out.peculiarities.value = stored.peculiarities;
            out.peculiarities.dispatchEvent(new Event('change'));
            out.numberKittens.value = stored.numberKittens;
            out.recommendedCalories.innerText = stored.calories;
        }
        const resetLink = document.createElement("a");
        resetLink.textContent = translations["Reset"] || "Reset";
        resetLink.href = "#";
        resetLink.addEventListener("click", (ev) => {
            window.localStorage.removeItem("calories_data_new")
            loadFromStorage();
            ev.preventDefault();
        })
        mainElement.appendChild(resetLink)
        mainElement.append("\r\n")
        const saveLink = document.createElement("a");
        saveLink.textContent = translations["Save"] || "Save";
        saveLink.href = "#";
        saveLink.addEventListener("click", (ev) => {
            window.localStorage.setItem("calories_data_new",
                JSON.stringify(
                    {
                        weight: out.weight.value,
                        age: out.age.value,
                        activity: out.activity.value,
                        peculiarities: out.peculiarities.value,
                        numberKittens: out.numberKittens.value,
                        calories: out.recommendedCalories.innerText
                    }
                )
            )
            // @ts-ignore
            ev.target.blur();
            ev.preventDefault();
        })
        mainElement.appendChild(saveLink)
        mainElement.querySelectorAll(".calories_close")
            .forEach(el => el.addEventListener("click", (ev) => {
                // @ts-ignore
                ev.target.blur();
                ev.preventDefault();
            }))

        // Observing changes and applying them to entire page
        function updateGlobals() {
            document.querySelectorAll('.global_calories_recommend').forEach(el => el.innerHTML = out.recommendedCalories.innerText + " Kcal");
            document.querySelectorAll('.calories_food_amount').forEach(el => el.innerHTML =  ""+Math.round(parseInt(out.recommendedCalories.innerText)*100/parseInt((el as any).dataset.cal)))
            document.querySelectorAll('.calories_price_day').forEach(el => {
                //console.log(el);
                const price = parseFloat((el as any).dataset.priceKg) // price in euro per kg
                const amount = parseInt(out.recommendedCalories.innerText)*100/parseInt((el as any).dataset.cal) // amount in grams
                el.innerHTML =  (Intl.NumberFormat(translations['locale'] ?? 'en-GB', {style: 'currency', currency:'EUR'}).format(price*amount/1000))
            })
        }
        const changeObserver = new MutationObserver(updateGlobals)
        changeObserver.observe(out.recommendedCalories, {
            characterData: true, subtree: true, childList: true
        })
        document.querySelectorAll('.calories_food_amount').forEach(el => 
            changeObserver.observe(el, {attributes:true}))

        // initial load
        loadFromStorage()
        updateGlobals()
    })

    // find food calorie forms and make them change calories_food_amount when changed
    document.querySelectorAll("#caloriesper100g").forEach(caloriesInput => {
        caloriesInput.addEventListener('change', input => {
            // @ts-ignore
            document.querySelectorAll('.calories_food_amount').forEach(el => el.dataset.cal = input.target.value);
        })
        caloriesInput.dispatchEvent(new Event('change'));
    });
});